import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";

@Component({
  selector: 'brt-youtube-video-overlay',
  templateUrl: './youtube-video-overlay.component.html',
  styleUrls: ['./youtube-video-overlay.component.scss']
})
export class YoutubeVideoOverlayComponent implements Overlayable, AfterViewInit {
  @ViewChild('dialogEl') dialogEl!: any;

  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  @Input('youtube-str') set setIframeStr(val: string) {
    this.src = val;
  }

  src = "";

  constructor() {
  }

  ngAfterViewInit() {
    console.warn("ngAfterViewInit")
    this.dialogEl?.nativeElement?.showModal();
  }
}
